/**
 * GameList Component - Displays and manages all bingo games
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Card from '../common/Card';
import Table from '../common/Table';
import Button from '../common/Button';
import api from '../../services/api';
import { ROUTES } from '../../utils/constants';
import './Games.css';

const GameList = () => {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGames();
  }, []);

  const loadGames = async () => {
    try {
      setLoading(true);
      const data = await api.getGames();
      setGames(data.games || data || []);
    } catch (error) {
      console.error('Error loading games:', error);
      toast.error('Error al cargar juegos');
    } finally {
      setLoading(false);
    }
  };

  const getStatusLabel = (status) => {
    const labels = {
      waiting: 'Esperando',
      in_progress: 'En Curso',
      paused: 'Pausado',
      completed: 'Completado',
      cancelled: 'Cancelado'
    };
    return labels[status] || status;
  };

  const columns = [
    { 
      key: '_id', 
      label: 'ID', 
      width: '100px',
      render: (val) => val?.substring(0, 8) + '...'
    },
    { 
      key: 'room', 
      label: 'Sala',
      render: (val) => val?.name || 'N/A'
    },
    { 
      key: 'status', 
      label: 'Estado', 
      render: (val) => (
        <span className={`status-badge status-${val}`}>
          {getStatusLabel(val)}
        </span>
      )
    },
    { 
      key: 'calledNumbers', 
      label: 'Números',
      render: (val) => `${val?.length || 0}/90`
    },
    { 
      key: 'players', 
      label: 'Jugadores',
      render: (val) => val?.length || 0
    },
    { key: 'prizePool', label: 'Premio' },
    { 
      key: 'createdAt', 
      label: 'Creado',
      render: (val) => val ? new Date(val).toLocaleString() : 'N/A'
    },
  ];

  return (
    <div className="game-list">
      <Card
        title="Juegos de Bingo"
        subtitle={`${games.length} juegos totales`}
        actions={<Button onClick={loadGames}>Actualizar</Button>}
      >
        <Table 
          columns={columns} 
          data={games} 
          loading={loading} 
          emptyMessage="No hay juegos. Los juegos se crean automáticamente cuando se inicia una partida en una sala."
        />
      </Card>
    </div>
  );
};

export default GameList;
